import React, { useRef } from 'react';
import ScanningPage from './ScanningPage.jsx';

const DocumentsPage = ({
	value = [],
	labels,
	helperTexts,
	text,
	onChange,
	requiredDocuments = [],
	possibleDocuments = [],
	uploadUrl = '/api/files',
	handleRequestException,
	exceptionText,
	name = 'userDocuments',
	useCamera,
	cameraIncludes,
	cameraRotationAngle,
	helperText,
	context,
	documentTypeForMultipleTypes,
	postUploadValidator,
	...rest
}) => {
	const valueRef = useRef(value);
	valueRef.current = value;

	const onChangeHandler = (index, processedDoc) => {
		const newValue = [...(valueRef.current || [])];
		newValue[index] = processedDoc;
		valueRef.current = newValue;
		return onChange({
			target: {
				name,
				value: newValue,
			},
		});
	};

	return (
		<ScanningPage
			possibleDocuments={possibleDocuments}
			requiredDocuments={requiredDocuments}
			onChange={onChangeHandler}
			uploadUrl={uploadUrl}
			value={value}
			labels={labels}
			helperTexts={helperTexts}
			text={text}
			handleRequestException={handleRequestException}
			exceptionText={exceptionText}
			useCamera={useCamera}
			cameraIncludes={cameraIncludes}
			cameraRotationAngle={cameraRotationAngle}
			helperText={helperText}
			context={context}
			documentTypeForMultipleTypes={documentTypeForMultipleTypes}
			postUploadValidator={postUploadValidator}
			{...rest}
		/>
	);
};

export default DocumentsPage;
